import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import NachReportNACHFieldUpdateModalUI from './NachReportNACHFieldUpdateModalUI.js'

class NachReportNACHFieldUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      included: true,
      remarks: '',
      remarksError: null,
      debitAmount: '',
      debitAmountError: null,
      debitDate: '',
      debitDateError: null,
    }
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    const opened = this.props.isOpen && !prevProps.isOpen
    const targetChanged =
      this.props.isOpen &&
      (prevProps.selectedAccountId !== this.props.selectedAccountId ||
        prevProps.updateKind !== this.props.updateKind)

    if (opened || targetChanged) {
      const rec = this.props.selectedRecord
      let debitAmountStr = '0.00'
      if (rec && rec.debitAmount) {
        const cleaned = String(rec.debitAmount).replace(/[^0-9.-]/g, '').trim()
        debitAmountStr = cleaned && !isNaN(cleaned) ? parseFloat(cleaned).toFixed(2) : '0.00'
      }

      this.setState({
        successMsg: null,
        errorList: null,
        submitted: false,
        included: rec && rec.included !== undefined ? !!rec.included : true,
        remarks: rec && rec.remark ? rec.remark : '',
        remarksError: null,
        debitAmount: debitAmountStr,
        debitAmountError: null,
        debitDate: rec && rec.debitDate ? rec.debitDate : '',
        debitDateError: null,
      })
    }
  }

  handleCancelClick = () => {
    this.setState({ submitted: false, successMsg: null, errorList: null })
    if (this.props.onCancelClick) {
      this.props.onCancelClick()
    }
  }

  render() {
    return (
      <NachReportNACHFieldUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        isOpen={this.props.isOpen}
        updateKind={this.props.updateKind}
        submitted={this.state.submitted}
        onSubmit={this.onSubmit}
        onCancelClick={this.handleCancelClick}
        selectedRecord={this.props.selectedRecord}
        included={this.state.included}
        onIncludedChange={(eventOrVal) => {
          if (typeof eventOrVal === 'boolean') {
            this.setState({ included: eventOrVal })
          } else if (eventOrVal && eventOrVal.target) {
            this.setState({
              included: eventOrVal.target.type === 'checkbox'
                ? eventOrVal.target.checked
                : eventOrVal.target.value === 'yes',
            })
          }
        }}
        remarks={this.state.remarks}
        onRemarksChange={(event) => {
          this.setState({ remarks: event.target.value, remarksError: null })
        }}
        remarksError={this.state.remarksError}
        setRemarksError={(err) => this.setState({ remarksError: err })}
        debitAmount={this.state.debitAmount}
        onDebitAmountChange={(event) => {
          this.setState({ debitAmount: event.target.value, debitAmountError: null })
        }}
        debitAmountError={this.state.debitAmountError}
        setDebitAmountError={(err) => this.setState({ debitAmountError: err })}
        debitDate={this.state.debitDate}
        onDebitDateChange={(event) => {
          this.setState({ debitDate: event.target.value, debitDateError: null })
        }}
        debitDateError={this.state.debitDateError}
        setDebitDateError={(err) => this.setState({ debitDateError: err })}
      />
    )
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }

  onSubmit = () => {
    if (this.state.submitted) return

    const { context, selectedAccountId, updateKind, yearMonth, selectedRecord } = this.props
    const record = selectedRecord || {}
    const accountId = String(selectedAccountId || record.accountId || '')
    if (!accountId) return

    const resolvedYearMonth = String(yearMonth || record.yearMonth || '')

    if (updateKind === 'remarks') {
      if (!this.state.remarks || !this.state.remarks.trim()) {
        this.setState({ remarksError: 'Please enter a remark' })
        return
      }
    }
    if (updateKind === 'debitAmount') {
      const trimmed = (this.state.debitAmount || '').trim()
      if (!trimmed || isNaN(trimmed) || parseFloat(trimmed) < 0) {
        this.setState({ debitAmountError: 'A valid amount is required' })
        return
      }
    }
    if (updateKind === 'decision') {
      const trimmed = (this.state.debitAmount || '').trim()
      if (trimmed && (isNaN(trimmed) || parseFloat(trimmed) < 0)) {
        this.setState({ debitAmountError: 'A valid amount is required' })
        return
      }
    }
    if (updateKind === 'debitDate') {
      const trimmed = (this.state.debitDate || '').trim()
      if (!trimmed) {
        this.setState({ debitDateError: 'Debit date is required' })
        return
      }
    }

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true,
    })

    // Prepare clean debitAmount string (e.g. "1533083.01")
    let debitAmountStr = '0.00'
    if (this.state.debitAmount != null && String(this.state.debitAmount).trim() !== '') {
      const cleaned = String(this.state.debitAmount).replace(/[^0-9.-]/g, '').trim()
      if (cleaned && !isNaN(cleaned)) {
        debitAmountStr = parseFloat(cleaned).toFixed(2)
      }
    } else if (record && record.debitAmount) {
      const cleaned = String(record.debitAmount).replace(/[^0-9.-]/g, '').trim()
      if (cleaned && !isNaN(cleaned)) {
        debitAmountStr = parseFloat(cleaned).toFixed(2)
      }
    }

    // Prepare clean remark string
    let remarkStr = ''
    if (this.state.remarks != null && String(this.state.remarks).trim() !== '') {
      remarkStr = String(this.state.remarks).trim()
    } else if (record && record.remark) {
      remarkStr = String(record.remark).trim()
    }

    // Prepare boolean included
    let includedVal = record.included !== false
    if (updateKind === 'included' || updateKind === 'decision') {
      includedVal = this.state.included === true
    }

    if (updateKind === 'debitDate') {
      const debitDateTrimmed = (this.state.debitDate || '').trim()
      const url = `/api/su/nach/monthly/debit-date?yearMonth=${encodeURIComponent(resolvedYearMonth)}&debitDate=${encodeURIComponent(debitDateTrimmed)}`
      const payload = { yearMonth: resolvedYearMonth, debitDate: debitDateTrimmed }
      RestApiUtils.put(context, url, this.onSubmitCallback, payload)
      return
    }

    if (resolvedYearMonth) {
      // Matches SuNachMonthlyUpdateDecisionRequestDTO:
      // private String yearMonth;
      // private String accountId;
      // private Boolean included;
      // private String debitAmount;
      // private String remark;
      const payload = {
        yearMonth: String(resolvedYearMonth),
        accountId: String(accountId),
        included: Boolean(includedVal),
        debitAmount: String(debitAmountStr),
        remark: String(remarkStr),
      }
      RestApiUtils.put(context, `/api/su/nach/monthly/decision`, this.onSubmitCallback, payload)
    } else {
      const base = `/api/accounts/${accountId}/loans`
      if (updateKind === 'remarks') {
        RestApiUtils.put(context, `${base}/updateNACHRemarks`, this.onSubmitCallback, {
          remarks: this.state.remarks,
        })
      } else if (updateKind === 'debitAmount') {
        RestApiUtils.put(context, `${base}/updateNACHDebitAmount`, this.onSubmitCallback, {
          amountF: this.state.debitAmount.trim(),
        })
      }
    }
  }

  onSubmitCallback = (response) => {
    if (!response) {
      this.setState({
        submitted: false,
        errorList: ['Request failed'],
      })
      return
    }
    const rawErrors = response.errorList || []
    const errorList = rawErrors.map((error) =>
      typeof error === 'string' ? error : error && error.message ? error.message : String(error)
    )

    const isError = rawErrors.length > 0 || response.success === false || response.status >= 400 || !!response.error

    this.setState({
      successMsg: !isError ? 'Updated successfully' : null,
      errorList: isError ? (errorList.length ? errorList : [response.message || response.error || 'Update failed']) : null,
      submitted: false,
    })

    if (!isError) {
      const ym = this.props.yearMonth || (this.props.selectedRecord && this.props.selectedRecord.yearMonth)
      if (ym) {
        CacheManager.removeObject(CacheKeys.NachMonthly(ym))
      }
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 800)
    }
  }
}

export default NachReportNACHFieldUpdateModalSF
